
import { memo, useState, useEffect, useCallback } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { BzInputText } from '../../../components';
import { GlobalSearchAddScripModal } from '../../Search';
import TabMutualFundContent from './TabMutualFundContent';
import { getSearchScripsMutualFunds,  searchMutulFundsSuccess, updateSearchMFScripDataStatusFailure } from '../../../redux/actions/globalSearch';
import { GLOBAL_SEARCH_MIN_LENGTH, MAX_SEARCH_MF_SCRIP_PER_PAGE } from '../../../utils/global_variables';
import { useDebounce } from '../../../hooks';
import RecentMutualFundsSearch from './RecentMutualFundsSearch';
import { getDecryptLocalStorage, setEncryptLocalStorage } from '../../../utils/global_functions';

// {/* BT-118877 Breeze - Mutual Fund-Global Search : Vinit R : 21/10/2023 - Start */ }
const Search = ({ show, onClick, onAddWatchlist, searchValue, setSelectedWatchListId, mutualFund, selectedWatchListId, filterWatchList, onHide, size, setShow, addToggle, setAddToggle, openWatchlists, handleTabClick, setTabSearchToggle, setIsShowingSearchBox, arrGlobalScripts, isShowingSearchBox, className, onChangeTabSearch, searchRef, scriptDetails, setScriptDetails, plus, setPlus, ...props }) => {
    const [strGlobalSearchMFInputText, setStrGlobalSearchMFInputText] = useState('');
    const [arrRecentlySearchMFScrips, setArrRecentlySearchMFScrips] = useState([]);
    const [isSearchScrips, setIsSearchScrips] = useState(false);
    const [isExpand, setIsExpand] = useState(false);
    const [currPageNo, setCurrPageNo] = useState(0);

    const dispatch = useDispatch()
    const objSearchMFScripData = useSelector(state => state.globalSearch.objSearchMFScripDataStatus);
    const { data: mfScrips, count } = useSelector(store => store.globalSearch.searchMFScrips);

    const handleExpand = () => {
        setIsExpand(!isExpand);
    };

    const onChangeGlobalSearch = useCallback((e) => {
        dispatch(searchMutulFundsSuccess({ data: [], count: 0 }));
        const strGlobalSearchText = e.target.value.toUpperCase();
        setStrGlobalSearchMFInputText(strGlobalSearchText);
        if (strGlobalSearchText?.length > 0 && strGlobalSearchText?.length >= GLOBAL_SEARCH_MIN_LENGTH) {
            useDebounce(() => {
                dispatch(getSearchScripsMutualFunds(strGlobalSearchText, -1, 0, MAX_SEARCH_MF_SCRIP_PER_PAGE, false));
            }, 1000);
        }
        else {
            dispatch(updateSearchMFScripDataStatusFailure({ status: true, strNoDataMessage: '' }));
        }
    }, [dispatch, setStrGlobalSearchMFInputText]);

    const handleOnClickMutualFundScrip = (arrScripData) => {
        if (arrRecentlySearchMFScrips?.length > 0) {
            let nIndex = arrRecentlySearchMFScrips.findIndex(eachScrip => eachScrip.token === arrScripData.token);
            if (nIndex !== -1) {
                if (nIndex > 0) {
                    arrRecentlySearchMFScrips.splice(nIndex, 1);
                    const updatedArray = [arrScripData, ...arrRecentlySearchMFScrips];
                    setArrRecentlySearchMFScrips(updatedArray);
                    saveMutualFundToLocalStorage(updatedArray);
                }
                else { }
            }
            else {
                const updatedArray = [arrScripData, ...arrRecentlySearchMFScrips];
                setArrRecentlySearchMFScrips(updatedArray);
                saveMutualFundToLocalStorage(updatedArray);
            }
        }
        else {
            const localArray = [...arrRecentlySearchMFScrips, arrScripData];
            setArrRecentlySearchMFScrips(localArray);
            saveMutualFundToLocalStorage(localArray);
        }
    };

    const saveMutualFundToLocalStorage = (arrScriptUpdated) => {
        setEncryptLocalStorage("RECENTLY_SEARCHED_MF", JSON.stringify(arrScriptUpdated));
    };

    
    const handleSearchScripsScroll = (e) => {
        if (e.target.scrollHeight <= Math.round(e.target.scrollTop + e.target.offsetHeight + 5)) {
            if (mfScrips.length < count) {
                dispatch(getSearchScripsMutualFunds(strGlobalSearchMFInputText, -1, currPageNo + 1, MAX_SEARCH_MF_SCRIP_PER_PAGE, false));
            }
            setCurrPageNo(curr => curr + 1);
        } else { }
    };

    useEffect(() => {
        const localStorageKey = "RECENTLY_SEARCHED_MF";
        const searchArray = getDecryptLocalStorage(localStorageKey);
        if (searchArray) {
            const parsedArray = JSON.parse(searchArray);
            setArrRecentlySearchMFScrips([...parsedArray]);
        } else { }
    }, []);

    useEffect(() => {
        if (!strGlobalSearchMFInputText || strGlobalSearchMFInputText?.length < GLOBAL_SEARCH_MIN_LENGTH) {
            setIsSearchScrips(false);

        } else {
            setIsSearchScrips(true);
        }
    }, [strGlobalSearchMFInputText]);

    return (
        <>
            <div className='global-search text-center d-flex align-items-center justify-content-center'>
                <div className='icon-24 icon-search icon-light icon-rotate' onClick={() => setShow(true)}></div>
            </div>

            {show === true ?
                <div className={`global-search-wrapper  ${isExpand ? 'global-search-expand' : ''}`}>
                    <div className='global-search-wrap' style={{ height: '100%' }}>
                        <Row className='g-0 global-search-header p-3'>
                            <Col md={10} className='d-flex justify-content-start'>
                                <BzInputText size="sm" className='font-regular bdr-none p-0 scripname-searchtext' type='search' value={strGlobalSearchMFInputText} placeholder='Search for Mutual Funds...' onChange={onChangeGlobalSearch} />
                            </Col>
                            <Col md={2} className='d-flex justify-content-end align-items-center'>
                                <div onClick={handleExpand} className='d-flex justify-content-end align-items-center'>
                                    <div className='icon-16 icon-expand icon-grey'></div>
                                </div>
                                <div onClick={() => { setShow(false); }} className='d-flex justify-content-end align-items-center'>
                                    <div className='icon-16 icon-close icon-grey ms-3'></div>
                                </div>
                            </Col>
                        </Row>
                        {!isSearchScrips && <RecentMutualFundsSearch scrips={arrRecentlySearchMFScrips} isExpand={false} onChangeGlobalSearch={onChangeGlobalSearch} />}                     
                        {!objSearchMFScripData.status && (
                            <div className='d-flex flex-column justify-content-center align-items-center'>
                                <div className='zero-state-alerts zero-state-alerts-lg'>
                                    <div className='icon-64 icon-nodata mb-3 mrgauto'></div>
                                    <div className='font-medium font-size2 color-text mb-1'>No matches found</div>
                                    <div className='font-regular font-size2 color-nodata'>Try adjusting your search to find what you are looking for</div>
                                </div>
                            </div>
                        )}
                        <Row onScroll={handleSearchScripsScroll} className='g-0 global-search-content' style={{ height: '100%' }}>
                            <TabMutualFundContent setShow={setShow} mutualFund={mutualFund} strGlobalSearchMFInputText={strGlobalSearchMFInputText} handleOnClickMutualFundScrip={handleOnClickMutualFundScrip} searchValue={searchValue} isShowing={isShowingSearchBox} showDefault isActive setAddToggle={setAddToggle} scriptDetails={scriptDetails} setScriptDetails={setScriptDetails} />
                        </Row>
                    </div>
                </div>

                : null
            }

            <GlobalSearchAddScripModal addToggle={addToggle} onAddWatchlist={onAddWatchlist} setSelectedWatchListId={setSelectedWatchListId} selectedWatchListId={selectedWatchListId} setAddToggle={setAddToggle} arrGlobalScripts={arrGlobalScripts} scriptDetails={scriptDetails} setScriptDetails={setScriptDetails} setPlus={setPlus} />
        </>



    );
};
// {/* BT-118877 Breeze - Mutual Fund-Global Search : Vinit R : 21/10/2023 - End */ }

export default memo(Search);